/* eslint-disable */
// @ts-nocheck
import { Assignment, MasterKeyHierarchyViewModel, SelectiveMaster } from './keying-models'
import { MasterKeyTypesList } from '@overtur-monorepo/keying-shared'

export class MasterKey {
  id: number
  masterKeySystemProfileId: number
  parentId?: number
  isSelectiveMaster: boolean
  budgetLimit: number
  budgetsCompleted: boolean
  hierarchyKeyName: string
  hierarchicalLevel: string
  levelOfKeying: any
  description: string
  children: MasterKey[] = []
  parent: MasterKey
  checked?: boolean
  indeterminateCheckBox?: boolean
  disabledCheckBox?: boolean
  isMasterOperator?: boolean
  isChangeKey?: boolean
  isChangeKeyNode?: boolean
  isSelectiveMasterNode?: boolean
  changeKeyExpansionFloor = 0
  keySetSymbol: string
  changeKeyExpansion: number
  changeKeyPosition: number
  currentLevel: number
  distanceFromTMK: number
  levelsOfKeying: number
  systemLevels: number
  crossKeyCylinders?: any
  directChangesOperate?: boolean
  openings = []
  budget: string
  library: any
  cylinders = []
  keyway
  keywayId: number
  masterKeyTypeId
  prefix?: string
  suffix?: string
  to?: string
  from?: string
  assignment: Assignment = { masterKey: null, reserved: false, kba: null }
  thruKeys
  rck
  crossKeyAssignments = []
  inFilter = true
  isFutureKey = false
  isAssigned = false
  isAssignedLocally = false
  unassignedLocally = false
  bitting: string
  isMinimized = false
  isCrossKeyOperator
  showOnUnassignedToggle?: boolean

  //new properties for hierarchy
  hierarchyPath: string = ''
  thruNotation: ThruNotationItem[] = []
  _level: number
  isSingleKeyDifferent: boolean
  // level: number
  //end new properties for hierarchy
  showMinimizedIcon? = false

  note
  notes = []
  isPublished
  isLegacyPublished

  selectiveMasters: SelectiveMaster[] = []
  lineTracker = {}

  readonly rectClass: string = 'rect'
  readonly minimizeClass: string = 'minimize'
  readonly moreClass: string = 'more'
  readonly descriptionClass: string = 'description'
  readonly selectedNodeClass: string = 'selected-node'
  readonly budgetClass: string = 'budget'
  element: SVGGElement
  changeKeyElement: SVGGElement
  selectiveMasterElement: SVGGElement
  disabled: boolean = false

  disableTMKToggling = false

  constructor(obj?: any) {
    Object.assign(this, obj)
  }

  get masterKeyType() {
    return MasterKeyTypesList.find((t) => t.id === this.masterKeyTypeId)
  }

  get minimize(): SVGRectElement[] {
    return this.element == null
      ? []
      : Array.from(this.element.getElementsByTagName('rect')).filter((r) => r.classList.contains(this.minimizeClass))
  }

  get more(): SVGRectElement[] {
    return this.element == null
      ? []
      : Array.from(this.element.getElementsByTagName('rect')).filter((r) => r.classList.contains(this.moreClass))
  }

  get budgetText(): SVGRectElement[] {
    return this.element == null
      ? []
      : Array.from(this.element.getElementsByTagName('rect')).filter((r) => r.classList.contains(this.budgetClass))
  }

  // get warning(): SVGRectElement[] {
  //   return this.element == null
  //     ? []
  //     : Array.from(this.element.getElementsByTagName('rect')).filter(r => r.classList.contains(this.warningClass));
  // }

  get rect(): SVGRectElement {
    return this.element == null
      ? null
      : Array.from(this.element.getElementsByTagName('rect')).filter((r) => r.classList.contains(this.rectClass))[0]
  }

  get lines(): SVGLineElement[] {
    return this.element == null ? [] : Array.from(this.element.getElementsByTagName('line'))
  }

  get paths(): SVGPathElement[] {
    return this.element == null ? [] : Array.from(this.element.getElementsByTagName('path'))
  }

  get texts(): SVGTextElement[] {
    return this.element == null ? [] : Array.from(this.element.getElementsByTagName('text'))
  }

  get maxDepth(): number {
    return Math.max(...this.squash().map((node) => node.level))
  }

  get selectiveMasterNode(): MasterKey {
    if (this.selectiveMasters.length === 0) {
      return
    }

    let selectiveMasterNode = new MasterKey()
    selectiveMasterNode.isSelectiveMasterNode = true
    selectiveMasterNode.element = this.selectiveMasterElement
    selectiveMasterNode.parentId = this.id
    selectiveMasterNode.parent = this
    selectiveMasterNode.keySetSymbol = `${this.selectiveMasters.length} Selective Masters`
    return selectiveMasterNode
  }

  get changeKeyNode(): MasterKey {
    if (this.changeKeys.length === 0) {
      return
    }

    let changeKeyNode = new MasterKey()
    changeKeyNode.isChangeKeyNode = true
    changeKeyNode.element = this.changeKeyElement
    changeKeyNode.parentId = this.id
    changeKeyNode.parent = this
    changeKeyNode.keySetSymbol = `${this.keySetSymbol} Change Keys`
    return changeKeyNode
  }

  get changeKeys(): Array<MasterKey> {
    return this.disabled ? [] : this.children.filter((c) => c.isChangeKey)
  }

  get masterKeys(): Array<MasterKey> {
    return this.disabled ? [] : this.children.filter((c) => !c.isChangeKey)
  }

  get sortedChildren(): Array<MasterKey> {
    if (this.disabled || !this.children || this.children.length === 0) {
      return []
    }

    // Define sort order priority: Selective Masters -> Change keys -> Master keys -> Cross Keyed -> Orphans
    const getSortPriority = (child: MasterKey): number => {
      // Selective Master keys (highest priority - 1)
      if (child.isSelectiveMaster || child.masterKeyTypeId === 11) {
        return 1
      }
      // Change keys (priority 2)
      if (child.isChangeKey || child.masterKeyTypeId === 10) {
        return 2
      }
      // Cross keyed cylinder nodes (priority 4)
      if (child.masterKeyTypeId === 12 || child.masterKeyTypeId === 13) {
        return 4
      }
      // Orphan nodes (lowest priority - 5)
      if (child.masterKeyTypeId === 14 || child.masterKeyTypeId === 15) {
        return 5
      }
      // Regular master keys and sub masters (priority 3)
      return 3
    }

    return [...this.children].sort((a, b) => {
      const aPriority = getSortPriority(a)
      const bPriority = getSortPriority(b)

      // Sort by priority, maintain original order if same priority
      return aPriority - bPriority
    })
  }

  get viewChildren(): Array<MasterKey> {
    const viewChildren = []
    if (this.changeKeyNode) {
      viewChildren.push(this.changeKeyNode)
    }
    this.children.filter((c) => c.isChangeKey === false).forEach((c) => viewChildren.push(c))
    return this.disabled ? [] : viewChildren
  }

  get level(): number {
    return this.parent == null ? 0 : this.parent.level + 1
  }

  set level(value: number) {
    this._level = value
  }

  get levelIndex(): number {
    if (this.parent == null) {
      return 0
    }
    if (this.previousSibling == null) {
      return this.parent.levelIndex
    }
    return this.previousSibling == null ? this.parent.levelIndex : this.previousSibling.deepestRightChild.levelIndex + 1
  }

  get deepestRightChild(): MasterKey {
    if (this.viewChildren.length === 0) {
      return this
    }
    return this.viewChildren[this.viewChildren.length - 1].deepestRightChild
  }

  get previousSibling(): MasterKey {
    if (this.parent == null) {
      return null
    }
    const index = this.parent.viewChildren.indexOf(this)
    return this.parent.viewChildren[index - 1]
  }

  destroy(node?: MasterKey): void {
    if (node == null) {
      return this.destroy(this)
    }
    if (node.element) {
      node.element.remove()
      node.element = null
    }
    for (const child of this.viewChildren) {
      child.destroy()
    }
  }

  highlightChain(enable: boolean): void {
    if (enable) {
      this.rect.classList.add('chain')
      for (const line of this.lines) {
        line.classList.add('chain')
      }
      for (const path of this.paths) {
        path.classList.add('chain')
      }
    } else {
      this.rect.classList.remove('chain')
      for (const line of this.lines) {
        line.classList.remove('chain')
      }
      for (const path of this.paths) {
        path.classList.remove('chain')
      }
    }
    if (this.parent == null) {
      return
    }
    this.parent.highlightChain(enable)
  }

  selectChain(enable: boolean): void {
    if (this.rect) {
      this.rect.classList.remove('chain')
      for (const line of this.lines) {
        line.classList.remove('chain')
      }
      for (const path of this.paths) {
        path.classList.remove('chain')
      }

      if (enable) {
        this.rect.classList.add('selected-chain')
        for (const line of this.lines) {
          line.classList.add('selected-chain')
        }
        for (const path of this.paths) {
          path.classList.add('selected-chain')
        }
      } else {
        this.rect.classList.remove('selected-chain')
        this.rect.classList.remove('selected-node')
        for (const line of this.lines) {
          line.classList.remove('selected-chain')
        }
        for (const path of this.paths) {
          path.classList.remove('selected-chain')
        }
      }
      if (this.parent == null) {
        return
      }
      this.parent.selectChain(enable)
    }
  }

  squash(): MasterKey[] {
    const arr = []
    arr.push(this)
    for (const child of this.viewChildren) {
      for (const node of child.squash()) {
        arr.push(node)
      }
    }
    return arr
  }

  squashIncludeChangeKeys(): MasterKey[] {
    const arr = []
    arr.push(this)
    for (const child of this.children) {
      for (const node of new MasterKey(child).squashIncludeChangeKeys()) {
        arr.push(node)
      }
    }
    return arr
  }

  tmk(): MasterKey {
    if (!this.parent) {
      return this
    }
    return this.parent.tmk()
  }
}

export interface ThruNotationItem {
  displayText: string
  isAssigned: boolean
  isRange: boolean
  masterKeyTypeId: number
  prefix?: string
  suffix?: string
  startNumber?: string
  endNumber?: string
  id?: number
}

// type Maybe<T> = T | null | undefined

// export class BaseMasterKey implements IKeyTreeHierarchyResponseVm {
//   id!: number
//   children: BaseMasterKey[] = []
//   parent?: BaseMasterKey
//   parentId?: number

//   bitting!: string
//   distanceFromTMK!: number
//   isAssigned!: boolean
//   isChangeKey: boolean = false
//   isConstructionKeyMaster: boolean = false
//   isControlKeyMaster: boolean = false
//   isCrossKeyOperator: boolean = false
//   isCrossKeyedMaster: boolean = false
//   isDirectChangeMaster: boolean = false
//   isFutureKey: boolean = false
//   isLegacyPublished: boolean = false
//   isMasterKey: boolean = false
//   isOrphanMaster: boolean = false
//   isPublished: boolean = false
//   isSingleKeyDifferent: boolean = false
//   isSingleKeyDifferentMaster: boolean = false
//   isTMK: boolean = false
//   keySetSymbol!: string
//   keySystemId!: number
//   keyway!: string
//   keywayId!: number
//   levelsOfKeying!: number
//   masterKeyTypeId!: number
//   assignment: Assignment = { masterKey: null, reserved: false, kba: null }
//   disabled: boolean = false
//   showMinimizedIcon: boolean = false
//   element?: SVGGElement
//   changeKeyElement?: SVGGElement
//   selectiveMasterElement?: SVGGElement
//   isMinimized: boolean = false

//   assignment?: Assignment = { masterKey: null, reserved: false, kba: null }
//   isAssignedLocally? = false
//   unassignedLocally? = false
//   inFilter? = false
//   crossKeyAssignments? = []
//   disableTMKToggling? = false
//   rck?: any

//   readonly rectClass = 'rect'
//   readonly minimizeClass = 'minimize'
//   readonly moreClass = 'more'
//   readonly descriptionClass = 'description'
//   readonly selectedNodeClass = 'selected-node'
//   readonly budgetClass = 'budget'

//   constructor(obj?: Partial<BaseMasterKey>) {
//     if (obj) Object.assign(this, obj)
//   }

//   get masterKeyType() {
//     return MasterKeyTypesList.find((t) => t.id === this.masterKeyTypeId)
//   }

//   protected getElementsByClass<T extends Element>(tagName: string, className: string): T[] {
//     if (!this.element) return []
//     return Array.from(this.element.getElementsByTagName(tagName)).filter((el) =>
//       el.classList.contains(className)
//     ) as T[]
//   }

//   get minimize(): SVGRectElement[] {
//     return this.getElementsByClass<SVGRectElement>('rect', this.minimizeClass)
//   }

//   get more(): SVGRectElement[] {
//     return this.getElementsByClass<SVGRectElement>('rect', this.moreClass)
//   }

//   get budgetText(): SVGRectElement[] {
//     return this.getElementsByClass<SVGRectElement>('rect', this.budgetClass)
//   }

//   get rect(): Maybe<SVGRectElement> {
//     return this.getElementsByClass<SVGRectElement>('rect', this.rectClass)[0]
//   }

//   get lines(): SVGLineElement[] {
//     if (!this.element) return []
//     return Array.from(this.element.getElementsByTagName('line'))
//   }

//   get paths(): SVGPathElement[] {
//     if (!this.element) return []
//     return Array.from(this.element.getElementsByTagName('path'))
//   }

//   get texts(): SVGTextElement[] {
//     if (!this.element) return []
//     return Array.from(this.element.getElementsByTagName('text'))
//   }

//   get changeKeys(): BaseMasterKey[] {
//     if (this.disabled) return []
//     return this.children.filter((c) => c.isChangeKey)
//   }

//   get masterKeys(): BaseMasterKey[] {
//     if (this.disabled) return []
//     return this.children.filter((c) => !c.isChangeKey)
//   }

//   get viewChildren(): BaseMasterKey[] {
//     if (this.disabled) return []
//     const viewChildren: BaseMasterKey[] = []
//     if (this.changeKeyNode) viewChildren.push(this.changeKeyNode)
//     viewChildren.push(...this.children.filter((c) => !c.isChangeKey))
//     return viewChildren
//   }

//   // get level(): number {
//   //   return this.parent ? this.parent.level + 1 : 0
//   // }

//   get levelIndex(): number {
//     if (!this.parent) return 0
//     const prevSibling = this.previousSibling
//     if (!prevSibling) return this.parent.levelIndex
//     return prevSibling.deepestRightChild.levelIndex + 1
//   }

//   get deepestRightChild(): BaseMasterKey {
//     if (this.viewChildren.length === 0) return this
//     return this.viewChildren[this.viewChildren.length - 1].deepestRightChild
//   }

//   get previousSibling(): Maybe<BaseMasterKey> {
//     if (!this.parent) return null
//     const siblings = this.parent.viewChildren
//     const index = siblings.indexOf(this)
//     return index > 0 ? siblings[index - 1] : null
//   }

//   destroy(node: BaseMasterKey = this): void {
//     if (!node) return
//     if (node.element) {
//       node.element.remove()
//       node.element = undefined
//     }
//     for (const child of node.viewChildren) {
//       child.destroy()
//     }
//   }

//   highlightChain(enable: boolean): void {
//     const toggleClass = (el: Element, className: string, enabled: boolean) => {
//       if (enabled) el.classList.add(className)
//       else el.classList.remove(className)
//     }

//     if (!this.rect) return

//     toggleClass(this.rect, 'chain', enable)
//     this.lines.forEach((line) => toggleClass(line, 'chain', enable))
//     this.paths.forEach((path) => toggleClass(path, 'chain', enable))

//     this.parent?.highlightChain(enable)
//   }

//   selectChain(enable: boolean): void {
//     if (!this.rect) return

//     const toggleClass = (el: Element, className: string, enabled: boolean) => {
//       if (enabled) el.classList.add(className)
//       else el.classList.remove(className)
//     }

//     // Remove chain classes always
//     toggleClass(this.rect, 'chain', false)
//     this.lines.forEach((line) => toggleClass(line, 'chain', false))
//     this.paths.forEach((path) => toggleClass(path, 'chain', false))

//     if (enable) {
//       toggleClass(this.rect, 'selected-chain', true)
//       this.lines.forEach((line) => toggleClass(line, 'selected-chain', true))
//       this.paths.forEach((path) => toggleClass(path, 'selected-chain', true))
//     } else {
//       toggleClass(this.rect, 'selected-chain', false)
//       toggleClass(this.rect, 'selected-node', false)
//       this.lines.forEach((line) => toggleClass(line, 'selected-chain', false))
//       this.paths.forEach((path) => toggleClass(path, 'selected-chain', false))
//     }

//     this.parent?.selectChain(enable)
//   }

//   squash(): BaseMasterKey[] {
//     return [this, ...this.viewChildren.flatMap((child) => child.squash())]
//   }

//   squashIncludeChangeKeys(): BaseMasterKey[] {
//     return [this, ...this.children.flatMap((child) => child.squashIncludeChangeKeys())]
//   }

//   tmk(): BaseMasterKey {
//     return this.parent ? this.parent.tmk() : this
//   }

//   abstract get selectiveMasterNode(): Maybe<BaseMasterKey>
//   abstract get changeKeyNode(): Maybe<BaseMasterKey>
// }

// export class MasterKeyBudget extends BaseMasterKey {
//   masterKeySystemProfileId!: number
//   isSelectiveMaster!: boolean
//   budgetLimit!: number
//   budgetsCompleted!: boolean
//   hierarchyKeyName!: string
//   hierarchicalLevel!: string
//   levelOfKeying!: any
//   description!: string
//   checked?: boolean
//   indeterminateCheckBox?: boolean
//   disabledCheckBox?: boolean
//   isMasterOperator?: boolean
//   isChangeKeyNode?: boolean
//   isSelectiveMasterNode?: boolean
//   changeKeyExpansionFloor = 0
//   changeKeyExpansion!: number
//   changeKeyPosition!: number
//   currentLevel!: number
//   systemLevels!: number
//   crossKeyCylinders?: any
//   directChangesOperate?: boolean
//   openings: any[] = []
//   budget?: string
//   library?: any
//   cylinders: any[] = []
//   prefix?: string
//   suffix?: string
//   to?: string
//   from?: string
//   thruKeys?: any
//   rck?: any
//   crossKeyAssignments: any[] = []
//   inFilter = true
//   isAssignedLocally = false
//   unassignedLocally = false
//   showOnUnassignedToggle?: boolean
//   showMinimizedIcon = false
//   note?: any
//   notes: any[] = []
//   selectiveMasters: SelectiveMaster[] = []
//   lineTracker = {}

//   constructor(obj?: any) {
//     Object.assign(this, obj)
//   }

//   get selectiveMasterNode(): Maybe<BaseMasterKey> {
//     if (this.selectiveMasters.length === 0) return null

//     const node = new MasterKeyBudget()
//     node.isSelectiveMasterNode = true
//     node.element = this.selectiveMasterElement
//     node.parentId = this.id
//     node.parent = this
//     node.keySetSymbol = `${this.selectiveMasters.length} Selective Masters`
//     return node
//   }

//   get changeKeyNode(): Maybe<BaseMasterKey> {
//     if (this.changeKeys.length === 0) return null

//     const node = new MasterKeyBudget()
//     node.isChangeKeyNode = true
//     node.element = this.changeKeyElement
//     node.parentId = this.id
//     node.parent = this
//     node.keySetSymbol = `${this.keySetSymbol} Change Keys`
//     return node
//   }
// }

// export class MasterKeyHierarchy extends BaseMasterKey {
//   hierarchyPath: string = ''
//   thruNotation: ThruNotationItem[] = []

//   constructor(obj?: Partial<MasterKeyHierarchy>) {
//     super(obj)
//   }

//   get selectiveMasterNode(): Maybe<BaseMasterKey> {
//     return null
//   }

//   get changeKeyNode(): Maybe<BaseMasterKey> {
//     return null
//   }
// }

// export class ThruNotationRangeNode extends BaseMasterKey {
//   thruNotationItem: ThruNotationItem

//   constructor(item: ThruNotationItem) {
//     super()
//     this.thruNotationItem = item
//     this.isRange = item.isRange
//     this.keySetSymbol = item.displayText
//   }

//   get selectiveMasterNode() {
//     return null
//   }

//   get changeKeyNode() {
//     return null
//   }
// }

// export interface IThruNotationRangeVm {
//   displayText: string
//   isAssigned: boolean
//   startNumber?: number | null
//   endNumber?: number | null
//   // Note: 'IsRange' is a computed property in C#, so it's not included here.
//   prefix?: string | null
//   suffix?: string | null
//   masterKeyTypeId?: number | null
// }

// export interface IKeyTreeHierarchyResponseVm {
//   keySystemId: number
//   id: number
//   parentId?: number | null
//   parentSymbol?: string | null
//   masterKeyTypeId: number
//   keySetSymbol: string
//   isAssigned: boolean
//   isFutureKey: boolean
//   isPublished: boolean
//   isLegacyPublished: boolean
//   isCrossKeyOperator: boolean
//   keywayId?: number | null
//   keyway?: string | null
//   bitting?: string | null
//   isTMK: boolean
//   isMasterKey: boolean
//   isControlKeyMaster: boolean
//   isConstructionKeyMaster: boolean
//   isDirectChangeMaster: boolean
//   isSingleKeyDifferentMaster: boolean
//   isCrossKeyedMaster: boolean
//   isOrphanMaster: boolean
//   isChangeKey: boolean
//   isSingleKeyDifferent: boolean
//   hierarchyPath?: string | null
//   level?: number | null
//   distanceFromTMK?: number | null
//   levelsOfKeying?: number | null
//   children: KeyTreeHierarchyResponseVm[]
//   thruNotation: ThruNotationRangeVm[]
// }
